<template>
  <basic-container>
    <!-- 社区居民管理 -->
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.communityresident_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>

      <template slot="areaIdForm">
        <el-select
          v-model="form.areaId"
          style="width: 100%"
          placeholder="请选择小区"
          :disabled="dialogType == 'view'"
        >
          <el-option
            v-for="(item, index) in areaIdList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
} from '@/api/v4ward/community/resident/communityresident';
import { residentialarealist } from '@/api/v4ward/community/residential/area/communityresidentialarea';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      dialogType: '',
      areaIdList: [],
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        searchShow: true,
        searchMenuSpan: 12,
        border: true,
        index: true,
        indexLabel:'序号',
        align:'center',
        viewBtn: true,
        selection: false,
        dialogClickModal: false,
        column: [
          {
            label: '主键',
            prop: 'id',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入主键',
                trigger: 'change',
              },
            ],
          },
          {
            label: '社区',
            prop: 'communityId',
            type: 'select',
            clear: false,
            dicUrl: '/api/v4ward/community/list',
            props: { label: 'name', value: 'id' },
            change: (value) => {
              this.form.areaId = '';
              this.areaIdList = [];
              console.log(value.value);
              if (value.value != '') {
                residentialarealist({
                  communityId: value.value,
                }).then((res) => {
                  this.areaIdList = res.data;
                  console.log(res);
                });
              }
            },
            span: 8,
            rules: [
              {
                required: true,
                message: '请输入社区',
                trigger: 'change',
              },
            ],
            search: true,
          },
          {
            label: '居民姓名',
            prop: 'name',
            maxlength:10,
            showWordLimit: true,
            span: 8,
            rules: [
              {
                required: true,
                message: '请输入居民姓名',
                trigger: 'change',
              },
            ],
            search: true,
          },
          {
            label: '联系电话',
            prop: 'phone',
            span: 8,
            rules: [
              {
                required: true,
                message: '请输入联系电话',
                trigger: 'change',
              },
              {
                pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/,
                message: '请输入正确的联系电话',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '性别',
            span: 8,
            prop: 'sex',
            dataType: 'number',
            type: 'select',
            dicUrl: 'api/blade-system/dict/dictionary?code=sex',
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [
              {
                required: true,
                message: '请输入性别',
                trigger: 'change',
              },
            ],
          },
          {
            label: '小区',
            prop: 'residentialAreaName',
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
          },
          {
            label: '小区',
            type: 'select',
            prop: 'areaId',
            dataType: 'string',
            formslot: true,
            hide: true,
            span: 8,
            dicData: [],
            props: { label: 'name', value: 'id' },
            rules: [
              {
                required: true,
                message: '请输入小区',
                trigger: 'change',
              },
            ],
          },
          {
            label: '住址',
            prop: 'address',
            maxlength:20,
            showWordLimit: true,
            span: 8,
            rules: [
              {
                required: false,
                message: '请输入住址',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注',
            span: 24,
            prop: 'remark',
            type: 'textarea',
            maxlength:200,
            showWordLimit: true,
            rules: [
              {
                required: false,
                message: '请输入备注',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  mounted(){
    this.ajustView()
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.communityresident_add, true),
        viewBtn: this.vaildData(this.permission.communityresident_view, true),
        delBtn: this.vaildData(this.permission.communityresident_delete, true),
        editBtn: this.vaildData(this.permission.communityresident_edit, true),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
     //设置表格高度
     ajustView() {
      const tableInitH = this.bodyHeight - 388; // 表格区域初始化高度
      const searchH = 56; // 搜索区域占的高度
      this.option.height = tableInitH;

      this.$nextTick(() => {
        setTimeout(() => {
          let children = this.$refs.crud.$children[1].$children;
          children[children.length - 2].$el.addEventListener('click', () => {
            if (this.option.height == tableInitH) {
              this.option.height = tableInitH + searchH;
            } else {
              this.option.height = tableInitH;
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });

      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      this.dialogType = type;
      this.form.areaId += '';
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}
</style>
